import React from 'react';
import { useQuery } from '@apollo/client';

import Loader from '../../../../components/Loader/Loader';
import NotFound from '../../../notFound/NotFound';

import { getPromoCode } from '../../../../lib/graphql';
import PromoCodeForm from '../../../../components/siteadmin/ManagePromoCode/PromoCodeForm/PromoCodeForm';

function EditPromoCode({ id, title }) {

    const { data, loading } = useQuery(getPromoCode, {
        variables: { id: Number(id) },
        fetchPolicy: 'network-only',
        ssr: false,
    });

    if (loading) {
        return <div><Loader type="text" /></div>;
    }

    if (!data?.getPromoCode) {
        return <NotFound />
    }
    const result = data?.getPromoCode?.result;

    const initialValues = {
        ...result,
        dynamicPromoCode: result?.dynamicPromoCode?.length > 0
            ? result.dynamicPromoCode
            : [{
                language: 'en',
                title: result?.title,
                description: result?.description,
            }]
    };

    return (
        <>
            <PromoCodeForm initialValues={initialValues} title={title} />
        </>
    );
}

export default EditPromoCode;